module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="scene-wrapper-outer">\n    <div class="scene-wrapper-inner">\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/viewer/SceneThumbnailViewer.tpl
// module id = 706
// module chunks = 0